/*
 * Author: zhanghj
 * Date: 2020-09-27 10:58:42
 * LastEditors: zhanghj
 * LastEditTime: 2020-09-27 17:51:34
*/
import React from 'react'
import { createForm } from 'rc-form'
import TextArea from './TextArea'

@createForm()
class Test extends React.Component {

  getData = () => {
    this.props.form.validateFields({ force: true }, (error, value) => {
      console.log(value)
    })
  }

  render() {
    return (
      <div>
        <TextArea props={this.props} />

        <button onClick={this.getData} style={{ width: '300px', height: '60px' }}>获取子组件数据</button>
      </div>
    )
  }
}

export default Test
